/** Shared modal chrome: overlay + card + header + body + footer, with
 *  backdrop/Escape close. Used directly for form dialogs and by DialogHost
 *  for imperative confirm/prompt/alert. */
import React, {useEffect} from "react";

import "/components/ui/Dialog.css";

interface DialogProps {
    open: boolean;
    title?: React.ReactNode;
    onClose: () => void;
    children: React.ReactNode;
    footer?: React.ReactNode;
    closeOnBackdrop?: boolean;
}

const Dialog: React.FC<DialogProps> = ({
    open, title, onClose, children, footer, closeOnBackdrop = true,
}) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="dlg" onClick={() => closeOnBackdrop && onClose()}>
            <div className="dlg__card" role="dialog" aria-modal="true"
                 onClick={(e) => e.stopPropagation()}>
                {title != null && title !== "" && (
                    <header className="dlg__head">
                        <h2>{title}</h2>
                        <button type="button" className="dlg__close" aria-label="Close" onClick={onClose}>×</button>
                    </header>
                )}
                <div className="dlg__body">{children}</div>
                {footer && <footer className="dlg__actions">{footer}</footer>}
            </div>
        </div>
    );
};

export default Dialog;
